import { useEffect, useState, useRef } from "react";
import "./styles.scss";

import { useNavigate, useParams } from "react-router-dom";
import api from "@helpers/api";

import { useCommunity } from "@contexts/CommunityContext";

import ManageSessionModal from "@modals/Content/ManageSession";
import ManageContentModal from "@modals/Content/ManageContent";
import ManagePlaylistModal from "@modals/Content/ManagePlaylist";


import Screen from "@components/Screen";


import Hero from "./components/Hero";
import EditionModeButton from "./components/EditionModeButton";
import ActionsRow from "./components/ActionsRow";
import Playlist from "./components/Playlist";
import SingleLesson from "./components/SingleLesson";


export default function ContentHub() {
  let { slug, section: sectionId } = useParams();

  const navigate = useNavigate();


  const [section, setSection] = useState({});

  // Inicializa o estado de edição do localStorage ou usa true como padrão
  const [editingEnabled, setEditingEnabled] = useState(() => {
    const stored = localStorage.getItem('contentHub_editingEnabled');
    return stored !== null ? JSON.parse(stored) : true;
  });

  const { community: communityManagement, loading: communityLoading } = useCommunity();

  const [loading, setLoading] = useState(true);

  const REF_configSessionModal = useRef();
  const REF_configPlaylistModal = useRef();
  const REF_configContentModal = useRef();

  // Função para atualizar o estado e salvar no localStorage
  const handleEditingToggle = (newValue) => {
    setEditingEnabled(newValue);
    localStorage.setItem('contentHub_editingEnabled', JSON.stringify(newValue));
  };

  // Sincroniza o estado com o localStorage quando necessário
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'contentHub_editingEnabled') {
        const newValue = e.newValue !== null ? JSON.parse(e.newValue) : true;
        setEditingEnabled(newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  useEffect(() => {
    if (loading && !communityLoading) handleLoad();
  }, [loading, communityLoading]);

  async function handleLoad() {
    try {
      const { data } = await api.get("section?id=" + sectionId);
      setSection({ ...data });
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  }

  function handleConfigureSession() {
    REF_configSessionModal.current.open({ ...section }, handleLoad);
  }
  function handleConfigurePlaylist(playlist = null) {
    REF_configPlaylistModal.current.open(
      { section: section.id, community: section.community, ...playlist },
      handleLoad
    );
  }
  function handleCreateSingleLesson() {
    REF_configContentModal.current.open({
      section: sectionId,
      community: communityManagement.getBySlug(slug).id
    }, handleLoad);
  }
  function handleOpenEditContent(content) {
    REF_configContentModal.current.open({
      ...content,
      section: sectionId,
      community: communityManagement.getBySlug(slug).id
    }, handleLoad);
  }
  function handleOpenContent(playlistInfo, index) {
    if (playlistInfo.single) {
      navigate("" + playlistInfo.id);
    } else {
      navigate("" + playlistInfo.content[index].id);
    }
  }

  const isAdmin = ['owner', 'creator'].includes(section?.role);

  if (loading) {
    return (
      <Screen fullWidth={true} className="contents-page" loading={true} />
    );
  }

  return (
    <>
      <Screen fullWidth={true} className="contents-page" disablePaddingBottom={true}>
        <Hero info={section} />

        <div className="playlists">

          {isAdmin && editingEnabled && (
            <ActionsRow
              handleCreatePlaylist={handleConfigurePlaylist}
              handleCreateSingleLesson={handleCreateSingleLesson}
              handleConfigureSession={handleConfigureSession}
            />
          )}

          {section?.content?.map((playlist, i) => (
            <>
              {playlist?.single ? (
                <SingleLesson
                  handleOpenContent={handleOpenContent}
                  content={playlist}
                  handleOpenEdit={isAdmin && editingEnabled ? handleOpenEditContent : null}
                />
              ) : (
                <Playlist
                  course={section.id}
                  handleOpenContent={handleOpenContent}
                  handleEdit={isAdmin && editingEnabled ? handleConfigurePlaylist : null}
                  handleAddContent={isAdmin && editingEnabled ? handleOpenEditContent : null}
                  handleEditContent={isAdmin && editingEnabled ? handleOpenEditContent : null}
                  content={playlist}
                  key={i}
                />

              )}
            </>
          ))}
        </div>

        {isAdmin && (
          <EditionModeButton
            editingEnabled={editingEnabled}
            onToggle={handleEditingToggle}
          />
        )}
        
      </Screen>

      <ManageSessionModal modalRef={REF_configSessionModal} />
      <ManagePlaylistModal modalRef={REF_configPlaylistModal} />
      <ManageContentModal modalRef={REF_configContentModal} />
    </>
  );
}
